import { ComplaintsService } from './../services/complaints.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { Complaint } from 'src/libs-common/models/complaint.model';
import { LettersOnlyValidator } from '../validators/letters-only.validator';
import { PhoneNumberValidator } from '../validators/phone-number.validator';
import { NotesValidator } from '../validators/notes.validator';
import { SnackService } from '../services/snack.service';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'app-complaints-page',
  templateUrl: './complaints-page.component.html',
  styleUrls: ['./complaints-page.component.scss'],
})
export class ComplaintsPageComponent implements OnInit {
  submitted = false;
  delivered = false;

  radioSelected: boolean | null = null;

  complaintForm = this.fb.group({
    date: [],
    nameFirst: [
      '',
      [Validators.required, this.lettersOnlyValidator.lettersOnlyValidator],
    ],
    nameLast: [
      '',
      [Validators.required, this.lettersOnlyValidator.lettersOnlyValidator],
    ],
    phone: [
      '',
      [Validators.required, this.phoneNumberValidator.phoneNumberValidator],
    ],
    email: [
      '',
      [
        Validators.email,
        Validators.pattern(
          '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'
        ),
      ],
    ],
    whoAmI: ['', Validators.required],
    onBehalfOfDisability: [null, Validators.required],
    complaint: ['', [Validators.required, this.notesValidator.notesValidator]],
    furtherImprovement: ['', this.notesValidator.notesValidator],
    additionalNotes: ['', this.notesValidator.notesValidator],
  });

  // This is a shorter form reference for the HTML Template
  get f(): any {
    return this.complaintForm.controls;
  }

  // This data object can be replaced by a call to the server when ready.
  data = {
    title: 'ADIEM | Make a complaint',
    description:
      "Here are ADIEM, we welcome any feedback or complaints. In fact, to give you better \
       services, we need your feedback. If you are not happy, tell us. It's OK to complain. \
       We won't be angry. So don't be shy. We need to know how you feel. Help us to do better!",
    image:
      'https://firebasestorage.googleapis.com/v0/b/adiem-prod.appspot.com/o/images%2Fplan-manager-contact-details.jpg?alt=media&token=e41695b6-4ead-49b9-916a-db16233ece18',
  };
  constructor(
    private fb: FormBuilder,
    private title: Title,
    private meta: Meta,
    private complaintsService: ComplaintsService,
    private lettersOnlyValidator: LettersOnlyValidator,
    private phoneNumberValidator: PhoneNumberValidator,
    private notesValidator: NotesValidator,
    private snackService: SnackService
  ) {}

  ngOnInit(): void {
    this.title.setTitle(this.data.title);
    this.meta.addTags([
      { name: 'twitter:card', content: 'summary' },
      { name: 'og:url', content: '/contact' },
      { name: 'og:title', content: this.data.title },
      { name: 'og:description', content: this.data.description },
      { name: 'og:image', content: this.data.image },
    ]);
  }

  submitForm() {
    this.findInvalidControls();

    if (this.complaintForm.valid) {
      const preparedData = this.prepareFormData();
      this.sendComplaint(preparedData);
    }
  }

  prepareFormData() {
    const formData = this.complaintForm.value;

    const preparedData: Complaint = {
      date: new Date(),
      nameFirst: formData.nameFirst,
      nameLast: formData.nameLast,
      phone: String(formData.phone).replace(/[^0-9]/g, ''),
      email: formData.email,
      whoAmI: formData.whoAmI,
      onBehalfOfDisability: formData.onBehalfOfDisability,
      complaint: formData.complaint,
      furtherImprovement: formData.furtherImprovement,
      additionalNotes: formData.additionalNotes,
    };

    return preparedData;
  }

  async sendComplaint(complaintData: Complaint) {
    this.submitted = true;
    this.delivered = false;

    this.complaintsService.sendEnquiry(complaintData).subscribe({
      next: (response) => {
        this.snackService.passMessage(
          'Complaint sent successfully',
          2000,
          `complaint-sent`
        );
        this.delivered = true;
      },
      error: (err) => {
        console.log('Error: ', err);
      },
      complete: () => {},
    });
  }

  findInvalidControls() {
    const invalid = [];
    const controls: any = this.complaintForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(`${name}: ${controls[name].value}`);
        controls[name].markAsTouched();
      }
    }
    if (invalid.length === 0) {
      console.log('Submitted Successfully');
    } else {
      console.log('Form has Invalid Controls: ', invalid);
    }
    return invalid;
  }
}
